import { render, staticRenderFns } from "./ContainerReferenceMain.vue?vue&type=template&id=1c5e6e52&scoped=true&"
import script from "./ContainerReferenceMain.vue?vue&type=script&lang=js&"
export * from "./ContainerReferenceMain.vue?vue&type=script&lang=js&"
import style0 from "./ContainerReferenceMain.vue?vue&type=style&index=0&id=1c5e6e52&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e6e52",
  null
  
)

export default component.exports